import React, { useState, useEffect, useCallback, memo } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { IRouteName, injectRouter } from '../../interface/route';
import Controller from '../../controllers/launch';
import { mapRouteToProps } from './arguments';
import { injectQueryURL } from '../../interface/util';
import { IRouteLaunchArguments } from '../../controllers/launch/interface';
import { injectConfigAPI } from '../../interface/config';
import { injectAPISession, sessionHook } from '@monofe/apiservice';

function LaunchRoute(props: RouteComponentProps<{}>): JSX.Element {
    const query = injectQueryURL();
    const router = injectRouter();
    const configAPI = injectConfigAPI();
    const session = sessionHook.useActiveSession();

    const [route, setRoute] = useState<IRouteLaunchArguments>(
        mapRouteToProps(props, query, session, configAPI),
    );

    const didRequestLanguageSelect = useCallback(() => {
        router.push(IRouteName.LanguageSelect, props.history, route, { replace: true });
    }, [props, router, route]);

    useEffect(() => {
        setRoute(mapRouteToProps(props, query, session, configAPI));
    }, [props, session, configAPI, query]);

    return (
        <Controller.renderer
            key="LaunchRoute"
            route={route}
            didRequestLanguageSelect={didRequestLanguageSelect}
        />
    );
}

const propsEqual = (prev: RouteComponentProps<{}>, next: RouteComponentProps<{}>) => {
    return (
        prev.location.search === next.location.search &&
        prev.location.pathname === next.location.pathname
    );
};

export default memo(LaunchRoute, propsEqual);
